import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/bka.jpg"


export const BKA = () => {    

    return (
        <SongLinks 
        title={"Blickkontaktabbruch"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/4yxxbsmil1YqbRsqQ5iYjk"}
        spotifyPresaveLink={"https://add-it.feiyr.com/MondWild/Blickkontaktabbruch"}
        appleMusicLink={"https://music.apple.com/de/song/blickkontaktabbruch/6768241879"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=v8oQVTsR-24&si=kacFM_m3dR_hs7S5"}
        youtubeLink={"https://youtu.be/2mafjyBAg-E"}
        tidalLink={"https://tidal.com/album/523527598/track/523527599"}
        amazonMusicLink={"https://www.amazon.de/music/player/albums/B0H1CM9519"}
        bandcampLink={"https://mondwild.bandcamp.com/track/blickkontaktabbruch"}
        releaseDate={"2026-06-26T00:00:00+02:00"}/>
    );
}